import { removeMultipleDots } from 'utils/removeMultipleDots';

const MAX_DECIMALS_LENGTH = 6;

export const etzFeeTransform = {
  mapper(event: React.ChangeEvent<HTMLInputElement>) {
    let value = event.target.value;

    value = value.replace(',', '.');
    value = value === '.' ? '0.' : value;
    value = value.replace(/^00+/g, '0');

    const cleanValue = removeMultipleDots(value.replace(/[^0-9.]/g, ''));

    const [intPart, decimalNumber] = cleanValue.split('.');

    if (decimalNumber && decimalNumber.length > MAX_DECIMALS_LENGTH) {
      return [intPart, decimalNumber.slice(0, MAX_DECIMALS_LENGTH)].join('.');
    }

    return cleanValue;
  },
};
